var cartContentCount = document.querySelector('.cart-content-count');

function updateCartContentCount(count) {
  cartContentCount.textContent = count;
}

// -------------------------------------------------------------------------------------------------
// Cart Class
// -------------------------------------------------------------------------------------------------
class Cart {
  constructor() {
    this.cartDrawerParent = null;
    this.windowWidth = window.innerWidth;
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }
  
  // -------------------------------------------------------------------------------------------------
  // Initialize the cart
  // -------------------------------------------------------------------------------------------------
  init() {
    this.cacheElements();
    this.bindEventListeners();
  }
  
  // -------------------------------------------------------------------------------------------------
  // Cache the elements
  // -------------------------------------------------------------------------------------------------
  cacheElements() {
    // Cart Drawer Elements
    this.cartDrawerParent = document.querySelector('#shopify-section-cart-drawer');
    this.cartDrawer = this.cartDrawerParent?.querySelector('#cart-drawer');
    this.cartMainDrawer = this.cartDrawerParent?.querySelector('.cart-main-drawer');
    this.cartUpsellsDrawer = this.cartDrawerParent?.querySelector('.cart-upsells-drawer');
    this.cartLoading = document.querySelector('#cart-loading');

    // Cart Drawer Triggers
    this.cartDrawerTrigger = document.querySelector('.site-header .nav-boat button[data-action="open-cart-drawer"]');
    this.openUpsells = this.cartDrawerParent?.querySelector('#open-upsells');
    this.closeCartUpsells = this.cartDrawerParent?.querySelector('.close-cart-upsells');
    this.closeCartToggle = this.cartDrawerParent?.querySelectorAll('.close-cart-drawer');
    this.cartOverlay = this.cartDrawerParent?.querySelector('.cart-overlay');

    // Cart Page Elements
    this.cart = document.querySelector('#main-cart');
    this.cartParent = this.cart?.parentElement;

    // Product Page Elements
    this.productForm = document.querySelector('#productForm');
  }

  // -------------------------------------------------------------------------------------------------
  // Bind event listeners
  // -------------------------------------------------------------------------------------------------
  bindEventListeners() {
    // Use event delegation for dynamic elements
    document.body.addEventListener('click', this.handleGlobalClick.bind(this));
    document.body.addEventListener('submit', this.handleProductFormSubmit.bind(this));

    // Bind events that don't change with cart updates
    if (this.cartDrawerTrigger) {
      this.cartDrawerTrigger.addEventListener('click', this.openCartDrawer.bind(this));
    }

    // Add click handler for quick add buttons
    document.body.addEventListener('click', this.handleQuickAddClick.bind(this));
  }

  // -------------------------------------------------------------------------------------------------
  // Handle global click events
  // -------------------------------------------------------------------------------------------------
  handleGlobalClick(event) {
    const target = event.target;
    const handlers = {
      '.close-cart-drawer': () => this.closeCartDrawer(),
      '.cart-overlay': () => this.closeCartDrawer(),
      '#open-upsells': () => this.toggleUpsells(true),
      '.close-cart-upsells': () => this.toggleUpsells(false),
      '.remove-item': () => this.removeItemFromCart(target.closest('.cart-item')),
      '.quantity-increase': () => this.handleAdjustItemQuantityClick(event),
      '.quantity-decrease': () => this.handleAdjustItemQuantityClick(event),
      '.cart-upsells-drawer .cart-item-add': () => this.handleAddCartDrawerUpsellsClick(event)
    };

    for (const [selector, handler] of Object.entries(handlers)) {
      if (target.closest(selector)) {
        handler();
        break;
      }
    }
  }

  // -------------------------------------------------------------------------------------------------
  // Utility function to toggle the upsells
  // -------------------------------------------------------------------------------------------------
  toggleUpsells(open) {
    if (open) {
      this.cartMainDrawer?.classList.add('closed');
    } else {
      this.cartMainDrawer?.classList.remove('closed');
    }
  }

  // -------------------------------------------------------------------------------------------------
  // Open the cart drawer
  // -------------------------------------------------------------------------------------------------
  openCartDrawer() {
    this.cartDrawer.classList.add('active');
  }

  // -------------------------------------------------------------------------------------------------
  // Close the cart drawer
  // -------------------------------------------------------------------------------------------------
  closeCartDrawer() {
    this.cartDrawer.classList.remove('active');
  }

  // -------------------------------------------------------------------------------------------------
  // Re-render the cart drawer
  // -------------------------------------------------------------------------------------------------

  reRenderCartDrawer(requiresOpen, cartDrawerHTML, cartPageHTML, cartCount) {
    if(this.cartDrawerParent) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartDrawerHTML, 'text/html');
      let cartDrawerContent = doc.querySelector('#shopify-section-cart-drawer').innerHTML;

      // If the cart drawer line items are interacted with
      // then we don't need to open the cart drawer
      //
      // Instead, grab the cart drawer element and add the active class to it
      // before the cart drawer content is re-rendered
      if(!requiresOpen) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cartDrawerContent;
        const cartDrawerElement = tempDiv.querySelector('#cart-drawer');
        if (cartDrawerElement) {
          cartDrawerElement.classList.add('active');
        }
        cartDrawerContent = tempDiv.innerHTML;
      }
      
      // Replace the content of the cart drawer with the new content
      this.cartDrawerParent.innerHTML = cartDrawerContent;
      
      // Cache the elements again (binding)
      this.cacheElements();
      
      // Applicable only when adding products to the cart from
      // outside the cart drawer
      if(requiresOpen) {
        setTimeout(() => {
          this.openCartDrawer();
        }, 500);
      }

      // Update the cart content count
      updateCartContentCount(cartCount);
    }

    if(this.cartParent) {
      this.cartParent.innerHTML = cartPageHTML;

      // Cache the elements again (binding)
      this.cacheElements();

      // Update the cart content count
      updateCartContentCount(cartCount);
    }
  }

  // -------------------------------------------------------------------------------------------------
  // Handle the product form submit
  // -------------------------------------------------------------------------------------------------
  handleProductFormSubmit(event) {
    if (event.target.matches('#productForm')) {
      event.preventDefault();
      this.addProductAndUpsellsToCart(event.target);
    }
  }

  // -------------------------------------------------------------------------------------------------
  // Handle the add cart drawer upsells click
  // -------------------------------------------------------------------------------------------------
  handleAddCartDrawerUpsellsClick(event) {
    if (event.target.closest('.cart-upsells-drawer .cart-item-add')) {
      this.addCartDrawerUpsellsToCart(event.target.closest('.cart-item'));
    }
  }

  // -------------------------------------------------------------------------------------------------
  // Handle the remove item click
  // -------------------------------------------------------------------------------------------------
  handleRemoveItemClick(event) {
    if (event.target.closest('.remove-item')) {
      this.removeItemFromCart(event.target.closest('.cart-item'));
    }
  }

  // -------------------------------------------------------------------------------------------------
  // Handle the adjust item quantity click
  // -------------------------------------------------------------------------------------------------
  handleAdjustItemQuantityClick(event) {
    const cartItem = event.target.closest('.cart-item');

    const currentQuantityElement = cartItem.querySelector('.current-quantity');
    let currentQuantity = parseInt(currentQuantityElement.textContent, 10);

    if (event.target.closest('.quantity-increase')) {
      currentQuantity += 1;
    } else if (event.target.closest('.quantity-decrease')) {
      currentQuantity -= 1;
    }

    this.adjustItemQuantityInCart(cartItem, currentQuantity);
  }

  // -------------------------------------------------------------------------------------------------
  // Function to add the product and upsells to the cart
  // -------------------------------------------------------------------------------------------------
  async addProductAndUpsellsToCart(form) {
    const submitButton = form.querySelector('#product-add');
    const quickAddBtns = document.querySelectorAll('.quick-add-to-cart-btn');

    if(submitButton) {
      submitButton.classList.add('adding');
      submitButton.querySelector('#product-add-btn-text').textContent = 'Adding to cart';
    }

    // Get the form data
    const formData = new FormData(form);

    // Get the tags from the hidden input
    const tags = formData.get('tags');

    const items = Array.from(formData.entries())
      .filter(([key]) => key.startsWith('product-option') || key === 'id')
      .map(([_, value]) => ({
        id: value,
        quantity: 1,
        properties: {
          _tags: tags
        }
      }));

    // Add the product(s) to the cart
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items, sections: ["cart-drawer"] }),
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        openPageMessage('Error', 'error', 'There was an error. You have added all available inventory to your cart.');
      } else {
        const data = await response.json();
        openPageMessage('Success', 'success', 'Product was added to cart.');
        const cartResponse = await fetch('/cart.js');
  
        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
  
          this.reRenderCartDrawer(true, data.sections['cart-drawer'], null, cartData.item_count);
        } else {
          console.error('Failed to fetch cart data');
        }
      }
    } catch (error) {
      openPageMessage('Error', 'error', 'There was an error. You have added all available inventory to your cart.');
    }
    
    if(submitButton) {
      submitButton.classList.remove('adding');
      submitButton.querySelector('#product-add-btn-text').textContent = 'Add to Cart';
    }

    if(quickAddBtns) {
      quickAddBtns.forEach(btn => {
        btn.querySelector('span').textContent = 'Add to Cart';
        btn.classList.remove('adding');
      });
    }

    // Hide the loading state
    this.cartLoading.classList.remove('active');
  }

  // -------------------------------------------------------------------------------------------------
  // Function to add the cart drawer upsells to the cart
  // -------------------------------------------------------------------------------------------------
  async addCartDrawerUpsellsToCart(cartItem) {
    // Show the loading state
    this.cartLoading.classList.add('active');

    // Get the variant ID
    const variantId = cartItem.dataset.variantId;
    
    // Prepare the payload
    const items = [{
      id: variantId,
      quantity: 1
    }];

    // Add the item to the cart
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items, sections: ["cart-drawer"] }),
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        openPageMessage('Error', 'error', 'Product was not added to cart. You may have added all available inventory.');
      } else {
        const data = await response.json();
        openPageMessage('Success', 'success', 'Product was added to cart.');

        const cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
          this.reRenderCartDrawer(false, data.sections['cart-drawer'], null, cartData.item_count);
        } else {
          console.error('Failed to fetch cart data');
        }
      }
    } catch (error) {
      openPageMessage('Error', 'error', 'Product was not added to cart. Please try again.');
    }

    // Hide the loading state
    this.cartLoading.classList.remove('active');
  }

  // -------------------------------------------------------------------------------------------------
  // Function to remove the item from the cart
  // -------------------------------------------------------------------------------------------------
  async removeItemFromCart(cartItem) {
    // Show the loading state
    this.cartLoading.classList.add('active');

    // Get the line key
    const lineKey = cartItem.dataset.lineKey;
    
    // Set the quantity to 0
    const updates = {
      [lineKey]: 0
    };

    // Remove the item from the cart
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ updates, sections: ["cart-drawer", "main-cart"] }),
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        openPageMessage('Error', 'error', 'Product was not removed from cart. Please try again.');
      } else {
        const data = await response.json();
        openPageMessage('Success', 'success', 'Product was removed from cart.');
        this.reRenderCartDrawer(false, data.sections['cart-drawer'], data.sections['main-cart'], data.item_count);
      }

    } catch (error) {
      openPageMessage('Error', 'error', 'Product was not removed from cart. Please try again.');
    }

    // Hide the loading state
    this.cartLoading.classList.remove('active');
  }

  // -------------------------------------------------------------------------------------------------
  // Function to adjust the item quantity in the cart
  // -------------------------------------------------------------------------------------------------
  async adjustItemQuantityInCart(cartItem, quantity) {
    // Show the loading state
    this.cartLoading.classList.add('active');

    // Get the line key
    const lineKey = cartItem.dataset.lineKey;
    
    // Set the quantity to the new quantity
    const updates = {
      [lineKey]: quantity
    };

    // Adjust the item quantity in the cart
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ updates, sections: ["cart-drawer", "main-cart"] }),
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        openPageMessage('Error', 'error', 'Product quantity was not updated. Please try again.');
      } else {
        const data = await response.json();
        this.reRenderCartDrawer(false, data.sections['cart-drawer'], data.sections['main-cart'], data.item_count);
      }

    } catch (error) {
      openPageMessage('Error', 'error', 'Product quantity was not updated. Please try again.');
    }

    // Hide the loading state
    // this.cartLoading.classList.remove('active');

  }

  // -------------------------------------------------------------------------------------------------
  // Function to handle quick add click
  // -------------------------------------------------------------------------------------------------
  handleQuickAddClick(event) {
    const quickAddBtn = event.target.closest('.quick-add-to-cart-btn');
    if (quickAddBtn) {
      quickAddBtn.classList.add('adding');
      quickAddBtn.querySelector('span').textContent = 'Adding...';
      
      const form = quickAddBtn.querySelector('form');

      if (form) {
        event.preventDefault();
        this.addProductAndUpsellsToCart(form);
      }
    }
  }
}

// Create a single instance of Cart
const cart = new Cart();
